import React, {useEffect,useState} from 'react'
import Header from '../components/header/Header';
import '../components/css/filmlister.css'
import { useNavigate } from "react-router-dom";
import doublearrow from '../images/double-arrow.png'
import checkmarkGreen from '../images/checkmark-green.png';
import close from '../images/close.png'
import searchIcon from '../images/search-26233.png'
import FilmlistDiv from '../components/FilmlistDiv';

function Filmlister() {
   const key = sessionStorage.getItem("key");
   const [bios, setBios] = useState([{}]);
   const [chosenBio, setchosenBio] = useState();
   const [orgID, setOrgID] = useState();
   const navigate = useNavigate();
   const [showFilms, setShowFilms]   = useState(false);
   const [error, setError] = useState(false);
   const [allMovies, setAllMovies] = useState([{}])
  const [filmSearch, setFilmSearch ]  = useState([])

      useEffect(() => {
        document.title = "Filmlister - ebillet_admin";
      }, []);
      
       const handleSelect = (e) => {
      let g = e.target.value;
        setchosenBio(e.target.value);

   // console.log(e)
    setOrgID(g.split(" ")[g.split(" ").length - 1]);
    // setSelected(e.target.value);
  };
       const svg = ` <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none">
               <path d="M0.353546 0.355469L8.85355 8.85547L17.3535 0.355469" stroke="#101010"/>
            </svg>`

          // get organizers fetch
           useEffect(() => {
              const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_getorganizers?Key=${key}`;
              if (key) {
                fetch(endpoint, {
                  method: "GET",
                  headers: {
                    ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                  },
                })
                  .then((res) => {
                    if (res.status !== 200) {
                      navigate("/");
                    }
                    return res.json();
                  })
                  .then((result) => {
                    // console.log(result)
                    setBios(result);
          
                    // console.log('biograf length',result.length)
                    if (result.length === 1) {
                    }
                    // setMovieNumber(result.map((number) => number.No));
                  });
              }
            }, [key]);

            useEffect(() => {
              if(orgID  && key ) { 
               const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_getprogram?Key=${key}&strOrganizers=${orgID}`;
    
      fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      })
     .then(res =>  {
   
        if(res.status === 200) {
          return   res.json() 

        }
        else {
              
        }
       
      })
      .then((result) => {
              setAllMovies(result.Movies)
      })
      }
            }, [key, orgID]);

              function handleShowFilm () {
        setShowFilms( current => !current)
  }
  const data = Object.values(filmSearch?.length ? filmSearch : toFindDuplicates(allMovies) )
  
  function toFindDuplicates(arr) {
    const uniqueElements = new Set(arr);
    // const filteredElements =
    arr.filter((item) => {
      if (uniqueElements.has(item)) {
        // uniqueElements.delete(item);
      } else {
        return item;
      }
    });

    return [...new Set(uniqueElements)];
  }

    /**---------search functions----------- */
    const [q, setQ] = useState("");
    const [searchParam] = useState(["name"]);
    const [filterParam, setFilterParam] = useState(["name"]);
  // console.log(filmSearch, 'film search')

 function search(items) {
      let events =  items
    return events.filter((item) => {
     
        if (filterParam == "name") {
            return searchParam.some((newItem) => {
                return (
                  item[newItem] && item[newItem]
                        .toString()
                        .toLowerCase()
                        .indexOf(q.toLowerCase()) > -1
                );
            });
        }
    });
   
  
  }
            let lists = [{name:'Honey'},{name:'Mango'},{name:'Lime'}]
  return (
    <div className='containers'>
          <Header filmlistActive='active'/>
          <main className='sms-container' style={{gridTemplateColumns:'20% 75.7% 62px',position:'relative',height:'1130px'}}>
            <aside className='aside'></aside>
            <div className='filmlister-container'>
                <p className='title' style={{width:'107px'}}>Filmlister</p>
                  <label htmlFor="" style={{fontSize:'18px',fontWeight:700,letterSpacing:'0.36px',color:'#46484c',marginBottom:'11px',marginTop:'30px'}}>Biograf</label>
                  <div className="movieListBox" style={{width: "384px",}}>  
                     <span className="select-line" style={{ backgroundColor: "#8d8d8d" ,position:'absolute',right:'30px',width:'0.5px'}}></span>
                    <select   className="form-select text-truncate"
                  value={chosenBio}
                  onChange={handleSelect}
                  style={{
                    height: "40px",
                    border: "1px solid #8d8d8d",
                    backgroundRepeat: "no-repeat",
                    color:'#46484c',
                     backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(svg)}")`,
                  }}
                >
                 {bios &&
                    bios.map((item) => {
                      let bb = item.City + " - " + item.Name + " " + item.No;
                      return (
                        <option
                          key={item.id}
                          value={bb}
                          className="text-truncate"
                          style={{
                            maxWidth:'380px',
                            marginLeft: "10px",
                            fontSize: "16px",width:'370px'
                          }}
                        >
                          {item.City} - {item.Name}
                        </option>
                      );
                    })}
          </select>
                 </div>
                 <div style={{display:'flex',justifyContent:'space-between',position:'relative'}}>
                   <div>
                     <label htmlFor="" style={{fontSize:'18px',fontWeight:700,letterSpacing:'0.36px',color:'#46484c',marginBottom:'11px',marginTop:'30px'}}>Vælg liste</label>
                     <div className="movieListBox" style={{width: "384px",}}>  
                     <span className="select-line" style={{ backgroundColor: "#8d8d8d" ,position:'absolute',right:'30px',width:'0.5px'}}></span>
                    <select   className="form-select text-truncate"
                //   value={chosenBio}
                //   onChange={handleSelect}
                  style={{
                    height: "40px",
                    border: "1px solid #8d8d8d",
                    backgroundRepeat: "no-repeat",
                    color:'#46484c',
                     backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(svg)}")`,
                  }}
                >
                 {bios &&
                    bios.map((item) => {
                      let bb = item.City + " - " + item.Name + " " + item.No;
                      return (
                        <option
                          key={item.id}
                          value={bb}
                          className="text-truncate"
                          style={{
                            maxWidth:'380px',
                            marginLeft: "10px",
                            fontSize: "16px",width:'370px'
                          }}
                        >
                          {/* {item.City} - {item.Name} */}Filmslider
                        </option>
                      );
                    })}
          </select>
                     </div>
                    </div>
                    <button className='dlt-film'>Slet inacktive film</button>
                  </div>
                  <section className='filmlists' style={{width:'981px',}}>
                    <div className='filmlist-head'><p style={{lineHeight:'40px'}}>Film</p>
                    <p style={{paddingLeft:'20px',lineHeight:'40px'}}>Aktiv fra</p>
                    <p style={{paddingLeft:'20px',lineHeight:'40px'}}>Aktiv til</p>
                    <p style={{lineHeight:'40px'}}>Trailer</p>
                    <p style={{lineHeight:'40px'}}>Plakat</p>
                    <p style={{width:'40px',lineHeight:'18px',textAlign:'center'}}>Slim-slider</p>
                    <p style={{width:'123px',lineHeight:'18px',textAlign:'center'}}>Fuldskærms-slider</p>
                    <p style={{lineHeight:'40px'}}>Nummer</p>
                    </div>
                    {lists.map((item,index) => {
                        return <FilmlistDiv index={index} item={item}/>
                    })}
                  </section>
                  <button className='add-film-btn'>Tilføj film fra listen til højre</button>
            </div>

            {showFilms === false ? 
            <aside className='programContainer_aside' style={{textAlign:'center',alignContent:'center',backgroundColor:'#ccced1'}}>
              <div onClick={handleShowFilm}>  <img src={doublearrow} alt="" /></div>           
            </aside>
             : ''}
             <div  style={{width:'400px',display: showFilms ? 'grid' : 'none', gridTemplateColumns: showFilms ? '1fr 1fr' : '',marginTop:'1px', top:0,height:'100%'}} className='chooseFilmContainer' >
                <aside className='programContainer_aside' style={{backgroundColor:'#ccced1',height:'1130px'}} >
                 
               <div className='vector'></div>
               <div  style={{marginTop:'42vh', transform:'rotate(180deg)',marginRight:'15px'}} onClick={handleShowFilm}>

                    <img src={doublearrow} alt="" />
                 
               </div>
               
            </aside>
                <div style={{ width:'338px',paddingLeft:'30px',border:'1px ',display:'grid',gridTemplateRows:'.1fr 1fr'}}>
                  <div>
                  <button style={{float:'right',border:'none', background:'none'}} onClick={handleShowFilm}>
                  <img src={close} alt='close'/> </button>
                  <br />
                  <br />
                  <br />
                <p className='choose_film' >Føj film til listen</p>
                <p></p>
                {/* <label style={{marginBottom:'10px'}}> Søg præsis <input type='checkbox' checked={searchPrecise} onChange={handlePreciseSearch}/></label> */}
               
                <div style={{position:'relative'}}>
                <input  className='search_film' placeholder='Søg efter film'  value={q}
                            onChange={(e) => setQ(e.target.value)}/> 

                  <span style={{position:'absolute', top:'7px',left:'10px'}}>
                  <img src={searchIcon} alt='search' height='20px'/></span>
              
                </div>
               
                <div className='image_container' style={{marginTop:'47px',rowGap:'15px'}}>
                    { search(toFindDuplicates(data)).filter((a,b) => { return a.name !== b.name}).map((movie,i) => (
                     <div style={{width:'125px',position:'relative'}}>
                    <img   src={`https://ebillet.dk/poster/`+movie.poster.large} id={i} name={movie.name} duration={movie.length} movieno={movie.No} alt={movie.name} width='125px' height='185px' />  
                      <button className='add-btn'>Tilføj</button>
                    </div>
                    )) }    
                </div>
              </div>
                <div id='imgdiv'>  </div>
            </div>
             </div>
          </main>
    </div>
  )
}

export default Filmlister